<template>
	<div class="map-marker" @click="onClick">
		<div class="map-marker__line"></div>
		<shape class="map-marker__shape" :shape="shape" v-if="shape"></shape>
		<div class="map-marker__ball" v-if="!shape">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import Shape from '@/components/reusable/Shape'
import mapboxgl from 'mapbox-gl'

export default {
	name: 'MapMarker',
	props: {
		map: {
			type: Object,
		},
		position: {
			type: Object,
			required: true,
		},
		shape: {
			type: String,
		},
	},
	components: {
		Shape,
	},
	data() {
		return {
			marker: null,
		}
	},
	watch: {
		map() {
			this.addToMap()
		},
		position() {
			this.updatePosition()
		},
	},
	methods: {
		addToMap() {
			if (this.map) {
				this.marker.addTo(this.map)
			}
		},
		updatePosition() {
			if (this.position) {
				this.marker.setLngLat(this.position)
			}
		},
		onClick(event) {
			this.$emit('marker-click', event)
		},
	},
	mounted() {
		this.marker = new mapboxgl.Marker({
			element: this.$el,
			anchor: 'bottom',
			offset: [0, -9],
		})
		this.updatePosition()
		this.addToMap()
	},
	beforeDestroy() {
		this.marker.remove()
	},
}
</script>

<style lang="scss">
.map-marker {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: $font-stack;
	color: white;
	font-size: $fs-xsmall;
	font-weight: $fw-bold;
}

.map-marker__shape {
	@include size(1.25rem);
}

.map-marker__ball {
	@include circle(1.25rem);
	background-color: theme-color(500);
	background: radial-gradient(75% 75% at 50% 15.41%, theme-color(300) 0%, theme-color(500) 100%);
	display: flex;
	align-items: center;
	justify-content: center;
}

.map-marker__line {
	position: absolute;
	width: 2px;
	height: 12px;
	background: linear-gradient(theme-color(700), theme-color(500) 50%);
	top: 100%;
	left: 50%;
	margin-bottom: -1px;
	margin-top: -1px;
	margin-left: -1px;
	border-radius: 1px;
}
</style>
